/**
 * @return {number}
 */
export function CompareArrayByScore(a, b) {
  return b[0].fScore - a[0].fScore;
}
